import { render, staticRenderFns } from "./DashTable.vue?vue&type=template&id=4760313a"
import script from "./DashTable.vue?vue&type=script&lang=js"
export * from "./DashTable.vue?vue&type=script&lang=js"
import style0 from "./DashTable.vue?vue&type=style&index=0&id=4760313a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports